import Link from "../Link"
import React from "react"
import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles((theme) => ({
  root: {
    lineHeight: 2,
    fontWeight: 400,
    fontSize: 16,
    textDecoration: "none",
    color: theme.palette.common.white,
    "&:hover": {
      color: theme.palette.secondary.main,
      textDecoration: "none",
    },
  },
}))

const FooterLink = ({ children, target, to }) => {
  const classes = useStyles()
  return (
    <Link className={classes.root} to={to} target={target}>
      {children}
    </Link>
  )
}

export default FooterLink
